/**
 * @description: Email Validation
 * @author: SAR TECH EASY
 * @param {*}
 * @function emailValidation
 * @date : 16-01-2023
 * Uppercase (A-Z) and lowercase (a-z) letters
 * Digits (0-9)
 * Characters such as ! # $ % & ' * + – / = ? ^ _ ` { | } ~
 * Character . ( period, dot or fullstop) but it should not be the first or last character
 * and should not come one after the other
 */
export const emailValidation = (email) => {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,9})+$/.test(email)) {
    return true;
  } else {
    return false;
  }
};

/**
 * @description: MobileNumber Validation
 * @author: SAR TECH EASY
 * @param {*}
 * @function: MobileNumber Validation
 * @date : 16-01-2023
 * Below Formats it will work
 * +XX-XXXX-XXXX
 * +XX.XXXX.XXXX
 * +XX XXXX XXXX (/^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/)
 */
//To check if the mobile number has only characters
export const mobileNumberValidation = (ph) => {
  if (/^[0-9]+$/.test(ph)) {
    return true;
  } else {
    return false;
  }
};

//To check if the object has only characters
export const characterValidation = (obj) => {
  if (/^\s|\s$/.test(obj)) {
    return false;
  } else {
    if (/^[a-zA-Z0-9& ]+$/.test(obj)) {
      return true;
    } else {
      return false;
    }
  }
};

//To check if the object has only characters
export const characternameValidation = (obj) => {
  if (/^\s|\s$/.test(obj)) {
    return false;
  } else {
    if (/^[a-zA-Z ]+$/.test(obj)) {
      return true;
    } else {
      return false;
    }
  }
};

export const spaceValidation = (str) => {
  return /\s/.test(str);
};

//To check if the object has characters and underscore
export const characternameUnderScoreValidation = (obj) => {
  if (/^\s|\s$/.test(obj)) {
    return false;
  } else {
    if (/^[a-zA-Z_]+$/.test(obj)) {
      return true;
    } else {
      return false;
    }
  }
};

//To check if the object has characters and underscore
export const characternameHypenValidation = (obj) => {
  if (/^\s|\s$/.test(obj)) {
    return false;
  } else {
    if (/^[a-zA-Z-]+$/.test(obj)) {
      return true;
    } else {
      return false;
    }
  }
};
//To check if the object has characters and underscore
export const characternameHypenAndSpaceValidation = (obj) => {
  if (/^\s|\s$/.test(obj)) {
    return false;
  } else {
    if (/^[A-Za-z][A-Za-z -]*$/.test(obj)) {
      return true;
    } else {
      return false;
    }
  }
};
//To check if the object has characters and numbers
export const characterNumberValidation = (obj) => {
  if (/^[0-9a-zA-Z]+$/.test(obj)) {
    return true;
  } else {
    return false;
  }
};

//Alphanumeric validation
export const alpahnumericValidate = (obj) => {
  if (/^[a-zA-Z0-9\\s]+$/.test(obj)) {
    return true;
  } else {
    return false;
  }
};

//Alphanumeric validation
export const alpahnumericAndSpaceValidate = (obj) => {
  if (/^[a-zA-Z0-9 ]+$/.test(obj)) {
    return true;
  } else {
    return false;
  }
};

export const validatePassword = (obj) => {
  const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  return specialChars.test(obj);
};

//Allow Alpha, Numeric and (-&)
export const characterWithSomeSPL = (obj) => {
  if (/^[a-zA-Z0-9&-()\s]+$/.test(obj)) {
    return true;
  } else {
    return false;
  }
};

//PanNumber validation
export const panNumberValidation = (obj) => {
  const regExp = /[A-Z]{5}[0-9]{4}[A-Z]{1}/;
  return regExp.test(obj);
};

//GSTNumber validation
export const gstNumberValidation = (obj) => {
  const regExp = /[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}/;
  return regExp.test(obj);
};

//Password Validation
export const strongPassword = (obj) => {
  if (
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$&*])[a-zA-Z\d!@#$&^*]+$/.test(obj)
  ) {
    return true;
  } else {
    return false;
  }
};

const escapeRegExpMatch = function (s) {
  return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
};
export const isExactMatch = (str, match) => {
  return new RegExp(`\\b${escapeRegExpMatch(match)}\\b`).test(str);
};

//Not Allow # and -
export const characterNotAllowHyphenAndhash = (obj) => {
  if (/^[^-#]*$/.test(obj)) {
    return true;
  } else {
    return false;
  }
};
// validation for A-Z, a-z and _
export const alphabetAndUnderscore = (obj) => {
  if (/^[A-Za-z_]+$/.test(obj)) {
    return true;
  } else {
    return false;
  }
};

// validation for A-Z, a-z and _
export const alphabetAndComma = (obj) => {
  if (/^[A-Z,]+$/.test(obj)) {
    return true;
  } else {
    return false;
  }
};
export const urlParamsToJSON = (url) => {
  let queryString = url.split('?')[1];
  let params = new URLSearchParams(queryString);
  let json = {};
  params.forEach(function (value, key) {
    json[key] = value;
  });
  return json;
};

// Default export containing all validation functions
const Validations = {
  emailValidation,
  mobileNumberValidation,
  characterValidation,
  characternameValidation,
  characterNumberValidation,
  spaceValidation,
  characternameUnderScoreValidation,
  characternameHypenValidation,
  characternameHypenAndSpaceValidation,
  alpahnumericValidate,
  alpahnumericAndSpaceValidate,
  validatePassword,
  characterWithSomeSPL,
  panNumberValidation,
  gstNumberValidation,
  strongPassword,
  isExactMatch,
  characterNotAllowHyphenAndhash,
  alphabetAndUnderscore,
  alphabetAndComma,
  urlParamsToJSON,
};

export default Validations;
